import * as React from 'react';
import { DeleteModal } from './delete-modal/delete-modal';
import { CheckAppStatusModal } from './check-app-status-modal/check-app-status-modal';
import { ReviewAppModal } from '@wix/app-market-collection-widget';
import { SupportModal } from './support-modal/support-modal';
import { composer } from '../../component-decorators/composer';
import { getOriginForBi } from '../../bi/biEvents';
import NewAppSettingsModal from './app-settings-modal/new-app-settings-modal';
export var ModalNames;
(function (ModalNames) {
    ModalNames["NONE"] = "none";
    ModalNames["DELETE"] = "delete";
    ModalNames["APP_STATUS"] = "checkAppStatus";
    ModalNames["APP_SETTINGS"] = "appSettings";
    ModalNames["RATE_APP"] = "rateApp";
    ModalNames["SUPPORT"] = "support";
    ModalNames["EDIT_REVIEW"] = "editReview";
})(ModalNames || (ModalNames = {}));
export var Modals = composer()
    .withExperiments()
    .compose(function (_a) {
    var openModalName = _a.openModalName, closeModal = _a.closeModal, app = _a.app, baseUrl = _a.baseUrl, authorizationHeader = _a.authorizationHeader, origin = _a.origin, editorUrl = _a.editorUrl, checkStatusUrl = _a.checkStatusUrl, settingsUrl = _a.settingsUrl, manageAppsStaticsUrl = _a.manageAppsStaticsUrl, deleteApp = _a.deleteApp, locale = _a.locale, msId = _a.msId, showUserActionNotification = _a.showUserActionNotification, editorType = _a.editorType, openDeleteModalAppInEditor = _a.openDeleteModalAppInEditor, experiments = _a.experiments;
    var shouldUseNewReviewAppModal = openModalName === ModalNames.RATE_APP ||
        openModalName === ModalNames.EDIT_REVIEW;
    var showSuccessToast = function (message) {
        if (showUserActionNotification) {
            showUserActionNotification({
                message: message,
                biName: 'review-app',
                type: 'SUCCESS',
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        openModalName === ModalNames.DELETE && (React.createElement(DeleteModal, { app: app, msId: msId, origin: origin, editorUrl: editorUrl, manageAppsStaticsUrl: manageAppsStaticsUrl, deleteApp: deleteApp, closeModal: closeModal, editorType: editorType, baseUrl: baseUrl, authorizationHeader: authorizationHeader, openDeleteModalAppInEditor: openDeleteModalAppInEditor })),
        openModalName === ModalNames.APP_STATUS && (React.createElement(CheckAppStatusModal, { checkStatusUrl: checkStatusUrl, closeModal: closeModal })),
        openModalName === ModalNames.APP_SETTINGS && (React.createElement(NewAppSettingsModal, { settingsUrl: settingsUrl, closeModal: closeModal })),
        shouldUseNewReviewAppModal && (React.createElement(ReviewAppModal, { locale: locale, appDefId: app.webSolutionBase.id, isOpen: true, closeFn: closeModal, showSuccessToast: showSuccessToast, additionalBiData: {
                msid: msId,
                tagType: 'manage_apps',
                platform: getOriginForBi(origin, editorType),
            } })),
        openModalName === ModalNames.SUPPORT && (React.createElement(SupportModal, { app: app, msId: msId, origin: origin, closeModal: closeModal, showUserActionNotification: showUserActionNotification, authorizationHeader: authorizationHeader, baseUrl: baseUrl, editorType: editorType }))));
});
//# sourceMappingURL=modals.js.map